import { Link } from '@backstage/ui';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';
import { useNavCollapsed } from './state';

export const SidebarLogo = () => {
  const collapsed = useNavCollapsed();

  return (
    <Link href="/" className="atlas-nav__logo" aria-label="На главную">
      {collapsed ? <LogoIcon /> : <LogoFull />}
    </Link>
  );
};
